import React, {useContext, useEffect, useState} from 'react';
import BreadContext from "../context/BreadContext";
import "../styles/BreadCrumbs.css"
import {Link} from "react-router-dom";
import {useLocation} from "react-router";

const BreadcrumbsItem = ({route}) => {
    // const {bread} = useContext(BreadContext);
    const [bread, setBread] = useState(JSON.parse(window.localStorage.getItem("routes")));
    const [loading, setLoading] = useState(true)
    // const location = useLocation();
    //
    useEffect(()=> {
        if(window.localStorage.getItem("routes")){
            if(window.localStorage.getItem("routes").includes(JSON.stringify(route))){
                let routes = JSON.parse(window.localStorage.getItem("routes"));
                let newRoute = []
                for(let i=0; i < routes.length; i++){
                    newRoute.push(routes[i]);
                    if(routes[i].name === route.name){
                        break;
                    }
                }
                window.localStorage.setItem("routes", JSON.stringify(newRoute))
            }else{
                let route1 = JSON.parse(window.localStorage.getItem("routes"));
                route1.push(route);
                window.localStorage.setItem("routes", JSON.stringify(route1))
            }
        }else{
            window.localStorage.setItem("routes", JSON.stringify(Array(route)));
        }
        setBread(JSON.parse(window.localStorage.getItem("routes")))
        setTimeout(() => {
            setLoading(false)
        }, 500)

    },[])
    return (
        <div className="text-center">
            {!loading &&
                <ul id="breadcrumb">
                    {bread.map(b => <li key={b.name}><Link to={b.path} state={b.state}>{b.name}</Link></li>)}
                </ul>
            }
        </div>

    );
};

export default BreadcrumbsItem;